/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

import {
  CabaProvider,
  ErrorBoundary,
  Features,
  GoogleAuthProvider,
  NotificationContainer,
  SnackbarProvider,
} from '@cloudpilots/components';
import { ThemeProvider } from '@material-ui/core/styles';
// TODO API: Uncomment if you use api hook
// import { ApiProvider } from 'hooks/api';
import PropTypes from 'prop-types';
import React from 'react';
import { config } from '../config';
import useTheme from './hooks/use-theme';

const ProviderStack = (props) => {
  const { children } = props;
  const { clientId, features } = config;
  const theme = useTheme();

  return (
    <ErrorBoundary>
      <Features enabled={features}>
        <GoogleAuthProvider clientId={clientId}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <CabaProvider>
              {/* TODO API: Uncomment if you use api hook */}
              {/* <ApiProvider> */}
              <ThemeProvider theme={theme}>
                <NotificationContainer />
                {children}
              </ThemeProvider>
              {/* TODO API: Uncomment if you use api hook */}
              {/* </ApiProvider> */}
            </CabaProvider>
          </SnackbarProvider>
        </GoogleAuthProvider>
      </Features>
    </ErrorBoundary>
  );
};

ProviderStack.propTypes = {
  children: PropTypes.any,
};

export { ProviderStack as default };
